module.exports = __webpack_public_path__ + "media/components/Bazaarvoice/icons/check-circle-8d4ae9867f5d4390b123aa7a918bca65.svg";